import React, { useContext } from 'react';
import { Redirect, Route } from 'react-router-dom';
import Loading from 'components/Loading';
import useWindowSize from 'hooks/useWindowSize';
import AdminLayout from 'layouts/AdminLayout';
import { AppContext } from 'shared/AppContext';
import storage from 'shared/storage';
import AdminMobileLayout from '../../layouts/AdminMobileLayout';

const AdminRoute = ({ component: Component, backgroundColor, ...rest }) => {
  const [width] = useWindowSize();

  const {
    state: { accountId },
  } = useContext(AppContext);

  return (
    <Route
      {...rest}
      render={(props) => {
        const user = storage.get('user', {});

        if (typeof user.role !== 'undefined') {
          if (user.role !== 'employee')
            return (
              <Redirect
                to={{
                  pathname: '/admin',
                  state: { from: props.location },
                }}
              />
            );
        } else {
          return (
            <Redirect
              to={{
                pathname: '/',
                state: { from: props.location },
              }}
            />
          );
        }

        return (
          <div>
            {width <= 860 ? (
              <AdminMobileLayout backgroundColor={backgroundColor}>
                {accountId ? <Component {...props} /> : <Loading />}
              </AdminMobileLayout>
            ) : (
              <AdminLayout>
                {accountId ? <Component {...props} /> : <Loading />}
              </AdminLayout>
            )}
          </div>
        );
      }}
    />
  );
};

export default AdminRoute;
